"use strict";

var commonDirectives = angular.module('commonDirectives', []);

commonDirectives.directive('clock', ['dateFilter', '$interval', 'storeService', function (dateFilter, $interval, storeService) {
    return {
        restrict: 'E',
        scope: {
            format: '@',
            storeTime: '='
        },
        link: function (scope, element, attrs) {
            var interval = 1000;
            var promise;
            var store;

            var updateTime = function () {
                scope.time = new Date(scope.time.getTime() + interval);
                if(store) {
                    element.html(dateFilter(scope.time, scope.format) + " " + store.timeZone);
                }
            };

            var getStoreTimeAndRunTimer = function () {
                store = storeService.getStore();
                if (scope.storeTime && store) {
                    if (promise) {
                        $interval.cancel(promise)
                    }
                    scope.time = scope.storeTime;
                    promise = $interval(updateTime, interval);
                    element.removeClass('hidden');
                } else {
                    element.addClass('hidden');
                }
            };

            getStoreTimeAndRunTimer();

            scope.$watch('storeTime', function (value) {
                getStoreTimeAndRunTimer();
            });

        }
    };
}]);